module.exports = __webpack_public_path__ + "img/hero-product.69baf9b.webp";